<script setup lang="ts">
import { computed } from 'vue';

import PartFooterNavigation from '@parts/part-footer-navigation.vue';
import PartTitleHead from '@parts/part-title-head.vue';
import SectionSettings from '@sections/section-settings.vue';
import FormRadioInput from '@form/form-radio-input.vue';
import ButtonPrimary from '@buttons/button-primary.vue';

import mockData from '/misc/settigns';
import { useSettings } from '@composables/settings';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
const {
	goToNext,
	goToBack,
	activeIndex,
	selection,
	currentGroup,
	checkCurrentPageAccess,
} = useSettings();

const fields = computed(() => {
	return {
		title: t('settingsProtocol.title'),
		subtitle: t('settingsProtocol.subtitle'),
		list: mockData.list,
		buttonNext: {
			title: t('common.buttons.continue'),
		},
		buttonBack: {
			title: t('common.buttons.back'),
		},
	}
});

checkCurrentPageAccess();
</script>

<template>
	<main class="page page-settings-index">
		<section-settings
			v-if="currentGroup"
		>
			<transition
					appear
					name="fade"
					style="--animation-delay: 0.1s"
				>
				<part-title-head
					v-if="fields.title || fields.subtitle"
					black left
					:title="fields.title"
					:subtitle="fields.subtitle"
					title-font="font-18-pro-medium"
					sub-title-font="font-regular"
					class="page-settings-index__content"
				></part-title-head>
			</transition>

			<!--
				Для <transition> нужно задать продолжительность анимации: animation-delay.
				Через "--animation-count" передаем количество элементов в списке, для построения продолжительсности.
			-->
			<transition
				appear
				name="show-up-container-items"
				:style="`--animation-delay: 0.3s;
				--animation-item-delay: 0.2s;
				--animation-duration: 0.6s;
				--animation-count: ${fields?.list?.length || 0}`"
			>
				<ul
					v-if="fields.list"
					class="page-settings-index__list"
				>
					<li
						v-for="(item, index) in fields.list" :key="index"
						class="page-settings-index__list-item"
					>
						<form-radio-input
							:value="item.id"
							v-model="selection.protocol"
							dark
							class="page-settings-index__list-field"
						>
							<template v-slot:default>
								{{ item.title }}
							</template>
						</form-radio-input>
					</li>
				</ul>
			</transition>

			<part-footer-navigation
				v-if="activeIndex + 1 !== currentGroup?.list?.length"
				class="page-settings-index__footer"
			>
				<button-primary
					@click.native="goToNext"
					:disabled="selection.protocol === null"
					class="page-settings-index__save"
				>
					{{ fields?.buttonNext?.title }}
				</button-primary>
			</part-footer-navigation>
			<button-primary
				v-else
				pink
				@click.native="goToBack"
				class="page-settings-index__save"
			>
				{{ fields?.buttonBack?.title }}
			</button-primary>
		</section-settings>
	</main>
</template>

<style lang="scss">
.page-settings-index {
	display: flex;
	flex-direction: column;
	flex: 1 1 auto;

	&__content {
		--title-gap: 1.6rem;
		margin-bottom: 2.4rem;
	}

	&__list {
		display: flex;
		flex-direction: column;
		gap: 0.8rem;
		margin-bottom: 2rem;
	}

	&__list-item {
		display: block;
	}

	&__save {
		width: 100%;
		margin-top: auto;
	}
}
</style>
